// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetAnswersRequest,
  TGetAnswersModel,
  IMappers,
  TGetAnswersResponse,
  IGetAnswersResponse,
  IGetAnswersResponseError,
} from './types';

export const defaultConfig: TGetAnswersModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'newbuilding-reviews',
  pathApi: '/v1/get-answers/',
  requestType: 'json',
} as TGetAnswersModel;

export function createGetAnswersModel(parameters: IGetAnswersRequest): TGetAnswersModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetAnswersOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetAnswersRequest;
}

export async function fetchGetAnswers<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetAnswersOptions<TResponse200, TResponse400>): Promise<TGetAnswersResponse | TResponse200 | TResponse400> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetAnswersModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetAnswersResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetAnswersResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetAnswersResponse;
}
